import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';

const Faq = () => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const loadFaqs = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/faqs`);
        const faqData = await res.json();

        if (Array.isArray(faqData)) {
          setFaqs(faqData);
        }
      } catch (error) {
        console.error("Error fetching FAQ data:", error);
      }
    };

    loadFaqs();
  }, []);

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">
        {/* Accordion Area */}
        <div className="rbt-accordion-area accordion-style-1 bg-color-white rbt-section-gap">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-12">
                <div className="rbt-accordion-style accordion">
                  <div className="section-title text-start mb--60">
                    <h4 className="title">FAQs</h4>
                  </div>
                  <div className="rbt-accordion-style rbt-accordion-04 accordion">
                    <div className="accordion" id="accordionExamplec3">
                      {faqs.map((faq, index) => (
                        <div className="accordion-item card" key={faq.id}>
                          <h2 className="accordion-header card-header" id={`heading-${faq.id}`}>
                            <button
                              className={`accordion-button ${index === 0 ? '' : 'collapsed'}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${faq.id}`}
                              aria-expanded={index === 0 ? 'true' : 'false'}
                              aria-controls={`collapse-${faq.id}`}
                            >
                              {faq.question}
                            </button>
                          </h2>
                          <div
                            id={`collapse-${faq.id}`}
                            className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                            aria-labelledby={`heading-${faq.id}`}
                            data-bs-parent="#accordionExamplec3"
                          >
                            <div className="accordion-body card-body">
                              {faq.answer}
                            </div>
                          </div>
                        </div>
                      ))}
                      {faqs.length === 0 && (
                        <p className="text-muted">No FAQs available.</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
        
      </main>

      <div className="rbt-progress-parent">
        <svg className="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>
    </>
  );
};

export default Faq;
